import { SIZES } from '../consts';

export default [
	{
		image: 'arve-kern-438126-unsplash.jpg',
		id: 'angel',
		name: 'Angel',
		breed: 'Afgan Hound',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 5,
		price: 299,
	},
	{
		image: 'jamie-street-564888-unsplash.jpg',
		id: 'cody',
		name: 'Cody',
		breed: 'Nova Scotia Duck Tolling Retriever',
		info: '',
		location: 'Berlin',
		size: SIZES.MEDIUM,
		rating: 3,
		price: 299,
	},
	{
		image: 'matthew-hamilton-792658-unsplash.jpg',
		id: 'winnie',
		name: 'Winnie',
		breed: 'Whoodle',
		info: '',
		location: 'Berlin',
		size: SIZES.MEDIUM,
		rating: 5,
		price: 299,
	},
	{
		image: 'tadeusz-lakota-1116051-unsplash.jpg',
		id: 'laika',
		name: 'Laika',
		breed: 'Hasky',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 4,
		price: 299,
	},
	{
		image: 'avi-richards-438741-unsplash.jpg',
		id: 'stella',
		name: 'Stella',
		breed: 'Boston Terrier',
		info: '',
		location: 'Berlin',
		size: SIZES.MEDIUM,
		rating: 5,
		price: 299,
	},
	{
		image: 'jf-brou-358069-unsplash.jpg',
		id: 'strelka',
		name: 'Strelka',
		breed: 'Samoyed',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 5,
		price: 299,
	},
	{
		image: 'matthew-henry-58760-unsplash.jpg',
		id: 'dexter',
		name: 'Dexter',
		breed: 'Pug',
		info: '',
		location: 'Berlin',
		size: SIZES.SMALL,
		rating: 5,
		price: 299,
	},
	{
		image: 'tim-zankert-370890-unsplash.jpg',
		id: 'coco',
		name: 'Coco',
		breed: 'Dalmatian',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 4,
		price: 299,
	},
	{
		image: 'daniel-hering-749907-unsplash.jpg',
		id: 'pepper',
		name: 'Pepper',
		breed: 'A good boy',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 5,
		price: 299,
	},
	{
		image: 'jonathan-daniels-416786-unsplash.jpg',
		id: 'molly',
		name: 'Molly',
		breed: 'Labrador',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 5,
		price: 299,
	},
	{
		image: 'michael-mroczek-254755-unsplash.jpg',
		id: 'athena',
		name: 'Athena',
		breed: 'A girl boy',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 5,
		price: 299,
	},
	{
		image: 'tsiri.jpg',
		id: 'tsiri',
		name: 'Tsiri',
		breed: 'Saluki',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 6,
		price: 299,
	},
	{
		image: 'dessi.jpg',
		id: 'dessi',
		name: 'Dessi',
		breed: 'Dachshund',
		info: '',
		location: 'Berlin',
		size: SIZES.SMALL,
		rating: 6,
		price: 299,
	},
	{
		image: 'jordan-davis-183742-unsplash.jpg',
		id: 'izzy',
		name: 'Izzy',
		breed: 'Boxer',
		info: '',
		location: 'Berlin',
		size: SIZES.MEDIUM,
		rating: 4,
		price: 299,
	},
	{
		image: 'mitchell-orr-389605-unsplash.jpg',
		id: 'madison',
		name: 'Madison',
		breed: 'Labrador',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 5,
		price: 299,
	},
	{
		image: 'twiggy.jpg',
		id: 'twiggy',
		name: 'Twiggy',
		breed: 'Sheltie',
		info: '',
		location: 'Berlin',
		size: SIZES.MEDIUM,
		rating: 6,
		price: 299,
	},
	{
		image: 'erda-estremera-583352-unsplash.jpg',
		id: 'minnie',
		name: 'Minnie',
		breed: 'Dachshund',
		info: '',
		location: 'Berlin',
		size: SIZES.SMALL,
		rating: 5,
		price: 299,
	},
	{
		image: 'ken-reid-290754-unsplash.jpg',
		id: 'willow',
		name: 'Willow',
		breed: 'Labrador',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 5,
		price: 299,
	},
	{
		image: 'murucutu-697904-unsplash.jpg',
		id: 'rudy',
		name: 'Rudy',
		breed: 'Irish Setter',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 4,
		price: 299,
	},
	{
		image: 'wei-wang-754704-unsplash.jpg',
		id: 'jack',
		name: 'Jack',
		breed: 'Pomeranian',
		info: '',
		location: 'Berlin',
		size: SIZES.SMALL,
		rating: 5,
		price: 299,
	},
	{
		image: 'gabriel-crismariu-1060681-unsplash.jpg',
		id: 'brutus',
		name: 'Brutus',
		breed: 'Bichon',
		info: '',
		location: 'Berlin',
		size: SIZES.SMALL,
		rating: 4,
		price: 299,
	},
	{
		image: 'lulu.jpg',
		id: 'lulu',
		name: 'Lulu',
		breed: 'Border Collie',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 6,
		price: 299,
	},
	{
		image: 'patrick-hendry-612619-unsplash.jpg',
		id: 'josie',
		name: 'Josie',
		breed: 'A good boy',
		info: '',
		location: 'Berlin',
		size: SIZES.MEDIUM,
		rating: 5,
		price: 299,
	},
	{
		image: 'yuki-dog-401147-unsplash.jpg',
		id: 'brandy',
		name: 'Brandy',
		breed: 'A good boy',
		info: '',
		location: 'Berlin',
		size: SIZES.MEDIUM,
		rating: 5,
		price: 299,
	},
	{
		image: 'heather-miller-456513-unsplash.jpg',
		id: 'archie',
		name: 'Archie',
		breed: 'Labrador',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 4,
		price: 299,
	},
	{
		image: 'marcus-cramer-481656-unsplash.jpg',
		id: 'diesel',
		name: 'Diesel',
		breed: 'German Shepherd',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 5,
		price: 299,
	},
	{
		image: 'samantha-scholl-157445-unsplash.jpg',
		id: 'lola',
		name: 'Lola',
		breed: 'Labrador',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 5,
		price: 299,
	},
	{
		image: 'jacob-ufkes-109329-unsplash.jpg',
		id: 'teddy',
		name: 'Teddy',
		breed: 'Golden Retriever',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 5,
		price: 299,
	},
	{
		image: 'marcus-wallis-471436-unsplash.jpg',
		id: 'ziggy',
		name: 'Ziggy',
		breed: 'Dachshund',
		info: '',
		location: 'Berlin',
		size: SIZES.SMALL,
		rating: 5,
		price: 299,
	},
	{
		image: 'sydney-rae-422172-unsplash.jpg',
		id: 'riley',
		name: 'Riley',
		breed: 'Labrador',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 4,
		price: 299,
	},
	{
		image: 'james-barker-560319-unsplash.jpg',
		id: 'jake',
		name: 'Jake',
		breed: 'Labrador',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 5,
		price: 299,
	},
	{
		image: 'marek-szturc-1114956-unsplash.jpg',
		id: 'belka',
		name: 'Belka',
		breed: 'Husky',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 5,
		price: 299,
	},
	{
		image: 'tadeusz-lakota-1060163-unsplash.jpg',
		id: 'baxter',
		name: 'Baxter',
		breed: 'Border Collie',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 3,
		price: 299,
	},
	{
		image: 'freddie-marriage-41870-unsplash.jpg',
		id: 'batman',
		name: 'Batman',
		breed: 'Weimaraner',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 4,
		price: 299,
	},
	{
		image: 'stephane-juban-579135-unsplash.jpg',
		id: 'sam',
		name: 'Sam',
		breed: 'Irish Wolfhound',
		info: '',
		location: 'Berlin',
		size: SIZES.LARGE,
		rating: 4,
		price: 299,
	},
];
